// extracted by mini-css-extract-plugin
module.exports = {"cart-container":"_3KXQ_nur flex flex-column justify-between","cartContainer":"_3KXQ_nur flex flex-column justify-between"};